import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import { UploadTab, UploadPreview, AdminLayout } from '.';
import { getBrowserStorageItem, setBrowserStorageItem } from '@utils/browserStorage';
import { BROWSER_STORAGE_KEYS } from '@constants';

const Style = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    position: absolute;
    top: 6rem;
    width: 100%;
    height: 100%;
    @media (min-width: 700px) {
        width: 700px;
    }
    >div:first-child {
        display: inherit;
    }
`;

const NavTabs = styled.div`
    button {
        border-bottom: 1px solid #dee2e6;
    }
`;

// TO-DO: Add ability to delete last blob in case of mistake.

export const Upload = () => {
    const [openTab, setOpenTab] = useState('Upload');
    const [blobUrl, setBlobUrl] = useState('');
    const { blobUrlKey } = BROWSER_STORAGE_KEYS;

    const handleTabChange = (evt) => {
        setOpenTab(evt.target.value);
    };

    // When the component mounts, load prior url if present
    useEffect(() => {
        const savedBlobUrl = getBrowserStorageItem(blobUrlKey);

        if (savedBlobUrl) {
            setBlobUrl(savedBlobUrl);
        }
    }, []);

    // Update the stored value of pdfUrl whenever it changes (unless it's an empty string)
    useEffect(() => { 
        if (blobUrl) {
            setBrowserStorageItem(blobUrlKey, blobUrl);
        }
    }, [blobUrl]);

    return (
        <AdminLayout>
            <Style>
                <NavTabs>
                    <button value='Upload' onClick={handleTabChange}>
                        Upload
                    </button>
                    <button value='Preview' onClick={handleTabChange}>
                        Preview
                    </button>
                </NavTabs>
                {
                    openTab === 'Upload' ? 
                    <UploadTab 
                        setBlobUrl={setBlobUrl}
                        blobUrl={blobUrl} /> 
                    : <UploadPreview blobUrl={blobUrl}/>
                }
            </Style>  
        </ AdminLayout>
    );
};

export default Upload;